// These definitions are needed for GetStream's JS SDK to work in the browser.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
(window as any).process = { env: {} };
window.global = window;
